export const EMPTY_BASELINE_PLAN: CarbonReductionPlan = {
    landlordSplitBasis: "both",
    carbonReductionMeasures: [],
    carbonReductionPlanUid: "",
    carbonReductionMeasureUids: [""],
    annualSummaries: [],
    carbonPolicyCosts: [],
    carbonReductionPlanOptions: {
        netPresentValueDiscountRate: 0.03,
    },
    startYear: 0,
    endYear: 0,
    firstYearAnnualCarbonEmissions: 0,
    firstYearEnergyConsumptionTotal: 0,
    planLifetimeCarbonEmissionsElectricity: 0,
    planLifetimeCarbonEmissionsNaturalGas: 0,
    planLifetimeCarbonEmissionsSteam: 0,
    planLifetimeCarbonEmissionsTotal: 0,
    planLifetimeEnergyConsumptionElectricity: 0,
    planLifetimeEnergyConsumptionNaturalGas: 0,
    planLifetimeEnergyConsumptionSteam: 0,
    planLifetimeEnergyConsumptionTotal: 0,
    splitPlanLifetimeEnergyCostElectricity: 0,
    splitPlanLifetimeEnergyCostNaturalGas: 0,
    splitPlanLifetimeEnergyCostSteam: 0,
    splitPlanLifetimeEnergyCostTotal: 0,
    planLifetimeCarbonPolicySavings: 0,
    planLifetimeCarbonPolicyCosts: 0,
    planLifetimeRevenue: 0,
    planLifetimeIncrementalRoi: 0,
    planLifetimeTotalRoi: 0,
    planLifetimeIncentives: 0,
    splitPlanLifetimeEnergyCostSavings: 0,
    splitPlanLifetimeIncrementalMeasureCosts: 0,
    splitPlanLifetimeTotalMeasureCosts: 0,
};

export const EMPTY_BUILDING_MODEL_CARBON_REDUCTION_PLAN: BuildingModelCarbonReductionPlan = {
    id: "",
    baselinePlan: EMPTY_BASELINE_PLAN,
    buildingModelUid: "",
    createdAt: "",
    name: "Baseline Plan",
    plan: EMPTY_BASELINE_PLAN,
    planType: "",
    buildingStateIsOutdated: false,
    isPublished: false,
    isReported: false,
};

export const findCarbonReductionPlanById = (id: string, plans: BuildingModelCarbonReductionPlan[]) => {
    const foundPlan = plans.find((plan) => plan.id === id.toString())?.plan;

    return foundPlan;
};
